// @ts-expect-error Untyped module
import Cookies from 'js-cookie';
export const getGoogleContactsSyncAlertValue = () => {
  return Cookies.get('googleContactsSyncAlert');
};